import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=08c9b6fd&scoped=true&"
import script from "./orderRefund.vue?vue&type=script&lang=js&"
export * from "./orderRefund.vue?vue&type=script&lang=js&"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=08c9b6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c9b6fd",
  null
  
)

export default component.exports